import {
  ClearAccountUsersAction,
  FetchUsersAction,
  FetchUsersFulfilledAction,
  FetchUsersRejectedAction,
  UsersType,
} from 'b2b-common/core/account/api/Users.types';
import {
  CLEAR_ACCOUNT_USERS,
  FETCH_USERS,
  FETCH_USERS_FULFILLED,
  FETCH_USERS_REJECTED,
} from './actionTypes';

const fetchUsers = (
  pageSize: number,
  startItem: number,
): FetchUsersAction => ({
  type: FETCH_USERS,
  payload: {
    pageSize,
    startItem,
  },
});

const fetchUsersFulfilled = (
  response: UsersType,
): FetchUsersFulfilledAction => ({
  type: FETCH_USERS_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchUsersRejected = (
  error: ErrorType,
): FetchUsersRejectedAction => ({
  type: FETCH_USERS_REJECTED,
  payload: {
    error,
  },
});

const clearAccountUsers = (): ClearAccountUsersAction => ({
  type: CLEAR_ACCOUNT_USERS,
});

export {
  clearAccountUsers,
  fetchUsers,
  fetchUsersFulfilled,
  fetchUsersRejected,
};
